import { dev } from '$app/environment';

const marks = new Map<string, number>();

export class Bench {
	private constructor() {}

	static mark(markName: string) {
		globalThis.performance?.mark?.(markName);
		marks.set(markName, performance.now());
	}

	static measure(measureName: string, startMarkName = measureName) {
		const result = Bench.measureInternal(measureName, startMarkName);
		if (dev) {
			console.debug(result);
		}
		return result;
	}

	private static measureInternal(measureName: string, startMarkName: string) {
		const measure = globalThis.performance?.measure?.(measureName, startMarkName);
		if (measure) {
			return {
				name: measureName,
				duration: measure.duration
			};
		}

		const mark = marks.get(startMarkName);
		if (!mark) {
			throw new Error(`Failed to get performance mark '${startMarkName}'`);
		}

		const duration = performance.now() - mark;
		return {
			name: measureName,
			duration
		};
	}
}
